import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
// import axios from "../../API/axios";
import axios, { PublicKey } from "../../API/axios";
import { Button, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import ReactSelect from "react-select";
import toast from "react-hot-toast";
import { NavLink, Link } from "react-router-dom";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { ChevronDown } from "react-feather";
import DataTable from "react-data-table-component";
import { Edit2, Trash2 } from "react-feather"; // Icons for Edit and Delete

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";

// import defaultImage from "../../../src/assets/images/Default_user_image.png";

function ManageCard() {
	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const [display, setDisplay] = useState(false);
	const [search, setSearch] = useState("");
	// console.log("candidateData", candidateData);
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	const [unAuthorizeError, setUnAuthorizeError] = useState("");
	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);


	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	const handleClose = () => {
		resetForm();
		setShow(false);
	};
	const [showupdate, setShowUpdate] = useState(false);
	const handleShowUpdate = () => setShowUpdate(true);
	const handleUpdateClose = () => {
		setShowUpdate(false);
	};

	const [addClass, setAddClass] = useState("");
	const [classType, setClassType] = useState("");
	const [classTypeName, setClassTypeName] = useState([]);

	const [candidateList, setCandidateList] = useState([]);
	const [candidateData, setCandidateData] = useState([]);

	const [classGroupBatch, setClassGroupBatch] = useState("Class");
	const [groupBatchType, setGroupBatchType] = useState("Class");

	const [originalCandidateList, setOriginalCandidateList] = useState([]); // Pure data ke liye
	const [originalData, setOriginalData] = useState([]); // Pure data ke liye


	const handleTabChange = (tab) => {
		console.log("tab", tab);
		const type = tab === 2 ? "Batch" : "Class";
		setGroupBatchType(type);
		setClassGroupBatch(type);
	};

	useEffect(() => {
		const filteredData = originalCandidateList.filter(item => item.type === classGroupBatch);
		setCandidateList(filteredData);
	}, [classGroupBatch, originalCandidateList]);



	const getGetAllCandidate = async () => {
		// setIsLoading(true)
		// setIsError(false)
		try {
			const requestData = {
				sessionId: sessionId,
				name: search,
				type: groupBatchType,
			};

			axios
				.post(`/Institute/GetCandidateClasses`, requestData)
				.then((response) => {
					const res = response.data?.responseData || [];
					setCandidateList(res);
					setCandidateData(res);

					setIsError(res.length === 0); // If no jobs, set error state
					setIsLoading(false);
				})
				.catch((err) => {
					console.error("Error fetching jobs:", err);
					setIsError(true); // Handle error state
					setIsLoading(false);
					if (err.response && err.response.status === 409) {
						// toast.error(err.response.data.message);
						console.error("Unexpected error:", err);
						setUnAuthorizeError(err.response.data.message)
						handleunauthModal()
					} else {
						console.error("Unexpected error:", err);

					}
				});

		} catch (e) {
			console.log("e========>", e);
			setIsError(true)
			if (e.response && e.response.status === 404) {
				setDisplay(true);
			}
		}
		finally {
			setIsLoading(false)
		}
	};

	useEffect(() => {
		getGetAllCandidate();
	}, [search, groupBatchType]);

	// .........................
	const [formChangedNew, setFormChangedNew] = useState(false); // Track if form is modified
	const [isSubmittingNew, setIsSubmittingNew] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChangeNew = (setter, value ,fieldName) => {
		setter(value);
		validateFormNew(fieldName, value);
	};

	// Validate form based on required fields
	const validateFormNew = (fieldName, value) => {
		const updatedClassTypeName = fieldName === "classTypeName" ? value : classTypeName;
		const updatedAddClass = fieldName === "addClass" ? value : addClass;
	
		const isClassTypeValid = !!updatedClassTypeName;
		const isAddClassValid = typeof updatedAddClass === "string" && updatedAddClass.trim() !== "";
	
		if (isClassTypeValid && isAddClassValid) {
			setFormChangedNew(true);
		} else {
			setFormChangedNew(false);
		}
	};
	

		const AddClass = () => {
			setDisplay(true);
			setIsSubmittingNew(true); // Disable the button during submission

			try {
				const data = {
					sessionId: sessionId,
					name: addClass,
					type: classType,
				};

				axios.post(`/Institute/AddCandidateClass`, data)
					.then((response) => {
						if (response.status === 200) {
							console.log("AddClass", response);
							toast.success(response.data.message);
							getGetAllCandidate();
							selectClassType("")
							resetForm();

						} else if (response.status === 400) {
							console.log("Class name already exists!");
							toast.error(response.data.message);
						}
					})
					.catch((error) => {
						console.log("Error", error);
						if (error.response) {
							const { status, data } = error.response;
							if (status === 400) {
								console.log("Class name already exists!");
								toast.error(data.message);
							} else {
								toast.error(data.message);
							}
						} else {
							console.log("Error: Network or unknown error");
							toast.error("An error occurred. Please try again later.");
						}
					});
			} catch (error) {
				console.log("Unexpected error", error);
				toast.error("An unexpected error occurred. Please try again.");
			} finally {
				setIsSubmittingNew(false); // Re-enable the button after submission
				setFormChangedNew(false); // Disable button until further input changes
			};

		};

		const resetForm = () => {
			setShow(false);
			setAddClass("");
			setClassType(null);
		};

		function selectClassType(val) {
			if (val) {
				setClassType(val.value);
				setClassTypeName(val);
			} else {
				setClassType(null);
				setClassTypeName(null);
			}


		}

		const classTypeOptions = [
			{ value: "Class", label: "Class" },
			{ value: "Batch", label: "Batch" },
		];

		const [activeTab, setActiveTab] = useState(1);

		const tabStyle = (isActive) => ({
			borderBottom: isActive ? "3px solid #feaa00" : "none",
			cursor: "pointer",
			width: "100px",
			height: "50px",
			lineHeight: "50px",
			textAlign: "center",
			// backgroundColor: isActive ? "#f0f0f0" : "#feaa00",
		});

		const columns = [
			{
				name: "GROUP NAME",
				center: true,
				sortable: true,
				minWidth: "150px",
				selector: (row) => row.name,
			},

			// {
			// 	name: "Number Of Candidate",
			// 	center: true,
			// 	sortable: true,
			// 	minWidth: "150px",
			// 	selector: (row) => row.status,
			// },
			{
				name: "Action",
				center: true,
				sortable: true,
				minWidth: "150px",
				// selector: (row) => row.status,
				cell: (row) => (
					<div>
						<EditIcon className="pointer me-2" onClick={() => { handleShowUpdate(); setclassid(row.id); setCandidateData(row) }} size={8} />

						<DeleteIcon className="pointer text-danger"
							onClick={() => {
								setshowDelete(!showDelete);
								setclassid(row.id)
							}}
							size={8} />
					</div>
				),


			},

		];


		//  .........................Update class and batch ......................

		// ..........................................................

		const [formChanged, setFormChanged] = useState(false); // Track if form is modified
		const [isSubmitting, setIsSubmitting] = useState(false);
		// Handle changes and mark form as modified
		const handleFieldChange = (setter, value, fieldName) => {
			setter(value);

			// Updated values
			const updatedAddClass = fieldName === "addClass" ? value : addClass;

			// Check if the required field is filled
			const isValid = updatedAddClass.trim() !== "";

			setFormChanged(isValid);
		};

		// ..........................................................


		const UpdateClass = () => {
			setDisplay(true);
			if (!formChanged || isSubmitting) return; // Prevent multiple submissions
			setIsSubmitting(true); // Disable the button during submission
			console.log("add class working");

			try {
				const data = {
					sessionId: sessionId,
					name: addClass,
					type: classGroupBatch,
					id: classid,
				};
				console.log("data====>", data);

				axios.post(`/Institute/UpdateCandidateClass`, data).then((response) => {
					console.log("Update Class", response);
					toast.success(response.data.message);
					getGetAllCandidate();
					setShow(false);
					setDisplay(false);
					handleUpdateClose();
					setFormChanged(false); // Disable the button after update
				});
			} catch (e) {
				console.log("Update Class");

				if (e.response && e.response.status === 404) {
				}
			} finally {
				setIsSubmitting(false); // Re-enable the button after submission
			}
		};

		useEffect(() => {
			if (candidateData) {
				setAddClass(candidateData?.name)
			}
		}, [candidateData]);

		//  .........................delete class and batch ......................

		useEffect(() => {
			setIsLoading(true)
			if (classGroupBatch === "Class") {
				setCandidateList(originalData.filter(item => item.type === "Class"));
			} else if (classGroupBatch === "Batch") {
				setCandidateList(originalData.filter(item => item.type === "Batch"));
			}
		}, [classGroupBatch]);


		const [classid, setclassid] = useState("");
		const [showDelete, setshowDelete] = useState(false);
		const handleRemoveClose = () => { setshowDelete(false) };

		const handleDelete = async () => {
			setDisplay(true);

			const Data = {
				sessionId: sessionId,
				id: classid,
				type: classGroupBatch,

			};
			console.log("Data22", Data);
			try {
				const response = await axios.post("/Institute/DeleteCandidateClass", Data, {
					headers: {
						PublicKey,
					},
				});
				console.log("DeleteCandidateClass", response);

				toast.success(response.data.message);
				getGetAllCandidate();
				setDisplay(false);
				handleRemoveClose();
			} catch (error) {
				console.error("Error deleting account:", error);
				toast.error(error.response.data.message);
			}
		};



		return (
			<>
				<section className="pricing-section-three container jobapplication bulkResume view-job-style application-drop-section">
					<div className="mt-2">
						<h4 className="orange-title">
							<span className="orange-box me-2"></span>
							Manage Class{" "}
						</h4>
					</div>
					<div className="container st3">
						<div className="tabButton d-flex w-100 ps-0 connectionTab mt-1">

							<NavLink
								onClick={() => handleTabChange(1)}
								style={tabStyle(classGroupBatch === "Class")}
							>
								<p className="f-14 m-0 tabName tab-color">Class</p>
							</NavLink>
							<NavLink
								onClick={() => handleTabChange(2)}
								style={tabStyle(classGroupBatch === "Batch")}
							>
								<p className="f-14 m-0 tabName tab-color">Batch</p>
							</NavLink>
						</div>
						<div className="tabContent">
							<div className="manage-search-container">
								<div className="manage-search-bar">
									<SearchIcon className="icon" />
									<input
										type="text"
										placeholder="Search..."
										className="manage-search-input"
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
								<button
									className="add-batch-btn manage-button"
									onClick={handleShow}
								>
									+ Add Groups
								</button>
							</div>
						</div>

						<div className="manage-batches-container">
							<h2 className="manage-heading">{classGroupBatch} List</h2>
						</div>

						{isLoading ? (
							<div className="row mt-2">
								<div className="col-md-12">
									<ShimmerDiv mode="light" height={120} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={120} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={120} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={120} width={'100%'} />
								</div>
							</div>
						) : isError ? (
							<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
								<img src={error} alt="404 Not Found" width={300} />
								{/* <p className="d-flex justify-content-center">There is no record to display</p> */}
							</div>
						)
							// : candidateList.length === 0 ? (  // Check for empty data *after* loading
							// 	<div className="mt-2 d-flex justify-content-center">
							// 		{/* <p>There are no records to display</p>  */}
							// 		<img src={error} alt="404 Not Found" width={300} />
							// 	</div>
							// ) 
							: (
								<div className="scroll-react-dataTable">
									<div className="react-dataTable react-table-colorclass">
										<DataTable
											noHeader
											pagination
											columns={columns}
											paginationPerPage={10}
											className="react-dataTable"
											sortIcon={<ChevronDown size={10} />}
											data={candidateList}
										/>
									</div>
								</div>
							)}

					</div>
				</section>

				<div className="manage-class-main-container">

					{/* .......add class modal....  */}

					<Modal show={show} onHide={handleClose} centered size="md">
						<Modal.Header>
							<Modal.Title>Add group</Modal.Title>
							<CloseSharpIcon className="pointer" onClick={handleClose} />
						</Modal.Header>
						<Modal.Body className="settings">
							{/* <div className="upload-icon text-center mb-3"></div> */}
							<Row>
								<Col md={6}>
									<Form.Group controlId="Name_Title">
										<Form.Label className="class-type">
											Type
											<span style={{ color: "red" }} className="ms-2">
												*
											</span>
										</Form.Label>
									</Form.Group>

									<div className="post-form-group">
										<ReactSelect
											options={classTypeOptions}
											// onChange={selectClassType}
											onChange={(selectedOption) =>
												handleFieldChangeNew(selectClassType, selectedOption, "classTypeName")
											}
											value={classTypeName}
											placeholder="Select Type"
											// styles={customStyles}
											classNamePrefix="react-select"
											className="form-control"
											styles={customStyles}
											isClearable={true}
										/>

									</div>
								</Col>

								<Col md={6}>
									<div className="post-form-group">
										<label htmlFor="about">
											Name{" "}
											<span style={{ color: "red" }} className="ms-2">
												*
											</span>
										</label>
										<input
											type="text"
											value={addClass}
											// onChange={(e) => setAddClass(e.target.value)}
											onChange={(e) =>
												handleFieldChangeNew(setAddClass, e.target.value, "addClass")
											}
											placeholder="Enter class name"
										/>
										{/* {display && !addClass ? (
										<span className="error_msg_lbl">Enter class name</span>
									) : null} */}
									</div>
								</Col>
							</Row>
							<div className="add-class-submit-button mt-4 d-flex justify-content-center">
								<Button
									// onClick={AddClass}
									className={`btn ${!formChangedNew || isSubmittingNew ? "disabled" : "enabled"}`}
									onClick={!formChangedNew || isSubmittingNew ? (e) => e.preventDefault() : AddClass}
									style={{ pointerEvents: formChangedNew ? "auto" : "none", border: "none", width: "90px" }}
								>Add</Button>
							</div>
						</Modal.Body>
					</Modal>


					{/* .......Update class modal....  */}

					<Modal show={showupdate} onHide={handleUpdateClose} centered size="md">
						<Modal.Header>
							<Modal.Title>Update group</Modal.Title>
							<CloseSharpIcon className="pointer" onClick={handleUpdateClose} />
						</Modal.Header>
						<Modal.Body className="settings">
							{/* <div className="upload-icon text-center mb-3"></div> */}
							<Row>

								<Col md={12}>
									<div className="post-form-group">
										<label htmlFor="about">
											Name{" "}
											<span style={{ color: "red" }} className=""> *</span>
										</label>
										<input
											type="text"
											value={addClass}
											// onChange={(e) => setAddClass(e.target.value)}
											// onChange={(e) => handleFieldChange(setAddClass, e.target.value)} // Track changes
											onChange={(e) => handleFieldChange(setAddClass, e.target.value, "addClass")}
											placeholder="Enter class name"
										/>
										{/* {display && !addClass ? (
										<span className="error_msg_lbl">Enter class name</span>
									) : null} */}
									</div>
								</Col>
							</Row>
							<div className="add-class-submit-button mt-4 d-flex justify-content-center">
								{/* <Button
								// onClick={UpdateClass} 
								className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
								onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : UpdateClass}
								style={{ pointerEvents: formChanged && !isSubmitting ? "auto" : "none", border: "none", width: "90px" }}
							>Update</Button> */}
								<Button
									className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
									onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : UpdateClass}
									style={{ pointerEvents: formChanged && !isSubmitting ? "auto" : "none", border: "none", width: "94px" }}
								>
									Update
								</Button>
							</div>
						</Modal.Body>
					</Modal>


					{/* .......delete modal....  */}

					<Modal show={showDelete} onHide={handleRemoveClose} centered>
						<Modal.Header >
							<Modal.Title>Confirm delete</Modal.Title>
							<CloseSharpIcon className="pointer" onClick={handleRemoveClose} />
						</Modal.Header>
						<Modal.Body className="settings">
							<div className=" mb-3">
								<p>Are you sure you want to delete your group?</p>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<button onClick={handleDelete} className="btn btn-danger me-2">
								Confirm delete
							</button>
							<button onClick={handleRemoveClose} className="btn btn-secondary">
								Cancel
							</button>
						</Modal.Footer>
					</Modal>

					{/* ...............UnAuthorize modal............  */}
					{unAuthorizeError ? (
						<Modal show={unauthModal} centered>
							<Modal.Header>
								<Modal.Title>Unauthorize session expired</Modal.Title>
							</Modal.Header>
							<Modal.Body className="settings">
								<div className=" mb-3">
									<p>{unAuthorizeError}</p>
								</div>
							</Modal.Body>
							<Modal.Footer>
								<Link
									className="pointer"
									to="/Login"
									onClick={() => {
										localStorage.removeItem("token"); // Remove authentication token
										sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
										localStorage.removeItem("Module");
									}}
								>
									<button className="btn btn-danger ">Login</button>
								</Link>
								{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

							</Modal.Footer>

						</Modal>
					) : (
						""
					)}

				</div>
			</>
		);
	}

	export default ManageCard;
